export const LIBRARY_TAB = {
  SAVED_PORTFOLIOS: 'library.main.SAVED_PORTFOLIO',
  FILTERED_COMPANIES: 'library.main.FILTERED_COMPANIES',
  DOWNLOADED_FILES: 'library.main.DOWNLOADED_FILES',
}

export const REGEXP_CHARACTERS_BLOCK = [
  '"',
  ':',
  '*',
  '?',
  '"',
  '<',
  '>',
  '|',
  '\\',
  '/',
]
export const MAX_INPUT_LENGTH = 255

export const FIELD_SORT_TABLE_PORTFOLIO_DETAIL = {
  CREATE_DATE: 'createDate',
  UPDATE_DATE: 'updateDate',
}

export const TYPE_SORT_FOLLOWING_LIST = {
  STATUS: 'Status',
  DELIVERY_DATE_ID: 'DeliveryDate',
}

export const TYPE_SORT = {
  ASCENDING: 'Ascending',
  DESCENDING: 'Descending',
}

export const TYPE_DELETE = {
  IN: 'IN',
  NOT_IN: 'NOTIN',
}

export const TIME_OUT_INPUT = 100

export const ROUTE_LIBRARY = {
  SAVED_PORTFOLIOS: '/library/savedPortfolios',
  FILTERED_COMPANIES: '/library/filteredCompanies',
  DOWNLOADED_FILES: '/library/downloadedFiles',
  FILTERED_COMPANIES_SETTING: '/library/filteredCompanies/setting',
}

export const LIST_STATUS = {
  ACTIVE: 1,
  TERMINATED: 2,
  SUSPENDED: 3,
  OTHERS: 4,
  REVOKED: 8,
  BRC_REVOKED: 9,
  DISSOLVED: 10,
  BANKRUPT: 11,
  NOT_OPERATING: 12,
}

export const STATUS_COLOR = {
  [LIST_STATUS.ACTIVE]: '#3DA967',
  [LIST_STATUS.BANKRUPT]: '#C8781A',
  [LIST_STATUS.BRC_REVOKED]: '#F58B00',
  [LIST_STATUS.DISSOLVED]: '#3A414B',
  [LIST_STATUS.NOT_OPERATING]: '#E8B714',
  [LIST_STATUS.OTHERS]: '#9C9C9C',
  [LIST_STATUS.REVOKED]: '#D375AE',
  [LIST_STATUS.SUSPENDED]: '#EC626D',
  [LIST_STATUS.TERMINATED]: '#E03643',
}

export const TYPE_DELETE_COMPANY = {
  ON_ROW_TABLE_DETAIl: 'ON_ROW_TABLE',
  ON_ROW_TABLE_FOLLOWING: 'ON_ROW_TABLE_FOLLOWING',
  ON_DETAIl: 'ON_DETAIl',
  ON_FOLLOWING: 'ON_FOLLOWING',
}

export const ROUTE_CAN_GO_TO_LIBRARY = {
  PORTFOLIO_SUMMARY: 'portfolioInsights',
  COMPANY_ANALYSIS: 'companyAnalysis',
  USER_MANAGEMENT: 'userManagement',
}

export const COMPONENT_NAME_CAN_GO_TO_LIBRARY = {
  [ROUTE_CAN_GO_TO_LIBRARY.PORTFOLIO_SUMMARY]: 'Portfolio Insights',
  [ROUTE_CAN_GO_TO_LIBRARY.COMPANY_ANALYSIS]: 'Company Analysis',
  [ROUTE_CAN_GO_TO_LIBRARY.USER_MANAGEMENT]: 'User Management',
}

export const COMPONENT_NAME_CAN_GO_TO_LIBRARY_VI = {
  [ROUTE_CAN_GO_TO_LIBRARY.PORTFOLIO_SUMMARY]: 'Portfolio Insights',
  [ROUTE_CAN_GO_TO_LIBRARY.COMPANY_ANALYSIS]: 'Company Analysis',
  [ROUTE_CAN_GO_TO_LIBRARY.USER_MANAGEMENT]: 'User Management',
}

export const PAGE_SIZE_OPTIONS = [
  { label: 20, value: 20 },
  { label: 50, value: 50 },
  { label: 100, value: 100 },
]

export const NOT_SET_VALUE = {
  label: 'library.main.NOT_SET',
  value: 0,
  isI18n: true,
}

export const MAX_SIZE_COMPANY = 500
export const MAX_SIZE_PORT = 300
